<template>
  <div :class="$style.field">
    <label :for="id">Subject</label>
    <input
      type="text"
      :id="id"
      v-model="value"
      placeholder="Describe the purpose of your call"
      :name="id"
      :autocomplete="id" />
    <p v-show="error && showError">{{error}}</p>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'

  const { mapState, mapMutations } = createNamespacedHelpers('activitySummary')

  export default {
    data () {
      return {
        id: 'title',
        value: '',
        showError: false
      }
    },
    computed: {
      ...mapState([
        'activity',
        'formErrors'
      ]),
      error () {
        return this.formErrors[this.id]
      }
    },
    watch: {
      'activity.title': {
        immediate: true,
        handler (value) {
          this.value = value || ''
        }
      },
      value (value) {
        this.handleValue(value)
      }
    },
    created () {
      this.$_activitySummary_config.EventBus.$on('ACTIVITY_FORM_SUBMITTED', () => {
        this.showError = true
      })

      this.handleValue(this.value)
    },
    methods: {
      ...mapMutations([
        'setTitle',
        'upsertFormData'
      ]),
      handleValue (value) {
        this.showError = false
        this.setTitle(value)
        this.upsertFormData({
          id: this.id,
          value,
          error: this.validate(value)
        })
      },
      validate (value) {
        return value.length > 250
          ? 'Subjects can be up to 250 characters'
          : null
      }
    }
  }
</script>

<style module lang="less" src="../custom-section/fields/field.less"></style>



// WEBPACK FOOTER //
// subject-input.vue?ba455686